import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { DOData, NJDocData, NJDocDefTemplate, componentVM } from '../DOData';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { DobuttonComponent } from '../dobutton/dobutton.component';

@Component({
  selector: 'cylib-section-menu',
  templateUrl: './section-menu.component.html',
  styleUrls: ['./section-menu.component.css']
})
export class SectionMenuComponent implements OnInit {
    @Input() public loaderKey: string;
    //#region accordionVM
    private _accordionVM: Array<DOData>;
    @Input() public set accordionVM(AccordionVM: Array<DOData>) {
        if (AccordionVM) {
            this._accordionVM = AccordionVM;
            this.InitAccordionState();
        }
    }
    //#endregion End accordionVM

    @ViewChildren(DobuttonComponent) ButtonComponents: QueryList<DobuttonComponent>;
    //#region events
    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() clickChkbox: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() tabEvent: EventEmitter<componentVM> =
        new EventEmitter<componentVM>();
    @Output() requestRows: EventEmitter<boolean> =
        new EventEmitter<boolean>();
    public get accordionVM(): Array<DOData> {
        return this._accordionVM;
    }
    //#endregion events
    private AccordionsOpen = new Array<boolean>();

    constructor(private data: DocDefPrimLibService) { }
    ngOnInit() {
        if (this._accordionVM == null) {
            this._accordionVM = new Array<DOData>();
        }
    }
    public getAccordionsVM(): Array<number> {
        let ret: Array<number> = new Array<number>();
        for (let i: number = 0; i < this.accordionVM.length; i++) {
            if (this.accordionVM[i].customParameters['Composite'] == 'Yes') {
                ret.push(i);
            }
        }
        return ret;
    }
    public getAccordionContentVM(acc: number): Array<DOData> {
        //let ret = this.accordionVM[acc];
        //return ret;
        return this.performFilterRow(this.accordionVM);
    }
    performFilterRow(row: Array<DOData>): Array<DOData> {
        return row.filter((d: DOData) => {
            return (d.customParameters['Composite'] == null)
        })
    }

    getTemplateCodeAccordion(acc: string): string {
        return this.accordionVM[acc].njDocDefTemplate.docDefTemplateId;
    }
    getTemplateAccordion(acc: string): NJDocDefTemplate {
        return this.accordionVM[acc].njDocDefTemplate;
    }
    getTemplateSectionCode(): string {
        if (this.accordionVM.length == 0)
            return '0'
        else
            return this.accordionVM[0].njDocDefTemplate.docDefSecId.toString();
    }

    InitAccordionState() {
        for (let i: number = 0; i < this.accordionVM.length; i++) {
            this.AccordionsOpen.push(i == 0);
        }
    }
    getAccordionClass(acc: number): string {
        let ret: string = "";
        if (this.accordionVM[acc].customParameters['Class'] == null) {
            ret = "collapse";
        } else {
            ret = this.accordionVM[acc].customParameters['Class'];
        }
        if (acc == 0) {
            ret = ret + " show";
        }
        return ret
    }
    getAccordionStyle(acc: number): object {
        let accordion = this.accordionVM[acc];
        let hidden = this.setHidden(accordion.customParameters);
        let disabled = this.setDisabled(accordion.customParameters);
        if (hidden) {
            return JSON.parse("visibility:hidden; width:0px; height:0px; margin:0px; padding:0px");
        }
        else if (accordion.customParameters['Styles'] == null) {
            if (disabled)
                return JSON.parse("disabled=\"true\"");
            return {};
        } else {
            let styles = this.data.replaceAll(accordion.customParameters['Styles'], "'", '"');
            if (disabled)
                return JSON.parse(styles + " disabled=\"true\"");
            return JSON.parse(styles);
        }
    }
    opened(acc: number) {
        console.log('Opened Link: ' + acc + ' ' + this.accordionVM[acc].njDocDefTemplate.docDefTemplateID);
        if (this.AccordionsOpen[acc])
            this.AccordionsOpen[acc] = false;
        else {
            for (let i: number = 0; i < this.accordionVM.length; i++) {
                this.AccordionsOpen[i] = (acc == i);
            }
            this.onclickBut(this.accordionVM[acc]);
        }
        this.AccordionsOpen
    }
    //#region events
    onTabEvent(message: componentVM) {
        this.tabEvent.emit(message);
    }
    onclickBut(message: DOData) {
        this.ButtonComponents.forEach((but: DobuttonComponent) => {
            if (but.DocDefTemplate.docDefTemplateID != message.njDocDefTemplate.docDefTemplateID)
                but.resetButClass();
        });
        this.clickBut.emit(message);
    }
    onclickChkbox(message: DOData) {
        //this.ButtonComponents.forEach((but: DobuttonComponent) => {
        //    if (but.DocDefTemplate.docDefTemplateID != message.njDocDefTemplate.docDefTemplateID)
        //        but.resetButClass();
        //});
        this.clickChkbox.emit(message);
    }
    onRequestRows(message: boolean) {
        this.requestRows.emit(message);
    }
    ngAfterViewInit() {
    }
    public getPrimitives(): Array<DOData> {
        let lstDoData: Array<DOData> = new Array<DOData>();
        this.ButtonComponents.forEach((TextBox: DobuttonComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = TextBox.DocData;
            DoDOData.customParameters = TextBox.customParameters;
            DoDOData.njDocDefTemplate = TextBox.DocDefTemplate;
            lstDoData.push(DoDOData);
        });

        return lstDoData;
    }
    //#endregion events
    setHidden(customParameters): boolean {
        if (customParameters.Hidden == 'Yes')
            return true;
        //is the the required seccode in the user's credentials
        else if (customParameters["HiddenIfMissingSecCode"]) {
            this.data.checkIfCodeInUserSecurity(customParameters["HiddenIfMissingSecCode"], this.data.LoaderKey).subscribe((ret: boolean) => {
                if (ret) {
                    return false;
                }
                else {
                    return true;
                }
            });
        }
        return false;
    }

    setDisabled(customParameters):boolean {
        if (customParameters.isReadOnly == 'Yes')
            return true;
        //has a youth been selected when it's required
        else if (customParameters["DisabledIfMissingYouthId"]) {
        }
        //is the the required seccode in the user's credentials
        else if (customParameters["DisabledIfMissingSecCode"]) {
            this.data.checkIfCodeInUserSecurity(customParameters["DisabledIfMissingSecCode"], this.data.LoaderKey).subscribe((ret: boolean) => {
                if (ret) {
                    return false;
                }
                else {
                    return true;
                }
            });
        }
        return false;
    }
}


